import './polyfill';
import PopupsManager from "./popups-manager";
import {affiliatesPopup, surveyPopup} from './popups';
import "./header";
import "./../vue/footer";
import "./../vue/header-menu";
import "./../vue/search";
import "./../vue/cart-fast";
import {
    addDataLayer,
    getScope, readCookie,
    reamazeClickHandler, setCookie,
} from './common';
import Vue from "../vue/common/vue-common";
import History from "../vue/components/common/History";
import Lazy from "../vue/components/common/Lazy";

window.cr$ = cr$;

PopupsManager.add(affiliatesPopup);
PopupsManager.add(surveyPopup);

cr$.ready(function () {

    // LGPD
    const POLICY_VERSION = 'v1';
    const confirmedPolicyVersion = readCookie('_chPolicy');
    const policyInfoPopUp = cr$.byId('policyInfoPopUp');

    if(policyInfoPopUp.exists() && confirmedPolicyVersion !== POLICY_VERSION) {
        policyInfoPopUp.css('display', 'block');

        cr$.byId('confirmPolicyButton').click(() => {
            policyInfoPopUp.css('display', 'none');
            let d = new Date();
            d.setTime(d.getTime() + (25 * 30 * 24 * 60 * 60 * 1000));
            setCookie('_chPolicy', POLICY_VERSION, d.toUTCString(), '/');
        });
    }

    window.dataLayer = window.dataLayer || [];

    let customerId = getScope("id");
    let hashEmail = getScope("email_hash");
    let email = getScope("email");
    let userName = getScope("user_name");
    let userAvatar = getScope("user_avatar");
    let reamazeAuthKey = getScope("reamaze_authKey");
    let isRegularCustomer = getScope("is_regular_customer");
    let isSalesRep = getScope("is_sales_rep");

    if (isRegularCustomer) {
        const historyEl = cr$.byId('product-history-list-container');
        if (historyEl.exists()) {
            requestIdleCallback(() => {
                new Vue({
                    el: historyEl.raw,
                    data() { return {stylizeTitle: window.location.pathname !== '/'}},
                    template: `
                        <Lazy>
                            <History :stylize-title="stylizeTitle"/>
                        </Lazy>`,
                    components: {Lazy, History}
                });
            });
        }
    }

    addDataLayer(customerId, email, hashEmail, userName, userAvatar, reamazeAuthKey, !isRegularCustomer ? 2 : 1);

    if (customerId) {
        requestIdleCallback(() => {
            cr$.byClass('logged').removeClass('hidden');
            cr$.byClass('desloged').addClass('hidden');
            if (!isRegularCustomer) {
                cr$.byClass('hidden-wholesaler').addClass('hidden');
                cr$.byClass('visible-wholesaler').removeClass('hidden');
            }
            if (isSalesRep) {
                cr$.byClass('hidden-sales-rep').addClass('hidden');
                cr$.byClass('visible-sales-rep').removeClass('hidden');
            }
            const userNameElement = cr$.byId('header-user-name').raw;
            if (userNameElement && (!userNameElement.innerText || userNameElement.innerText.length === 0)) {
                userNameElement.innerText = decodeURI(userName).split('+').join(' ');
            }
        });
    }

    cr$.byId('top-promo-image').click(function () {
        const el = cr$.byEl(this),
            name = el.attr('data-name');

        if (name && name.length > 0)
            dataLayer.push({
                event: 'promotionClick',
                ecommerce: {
                    promoClick: {
                        promotions: [
                            {
                                id: el.attr('data-id'), // Name or ID is required.
                                name: name,
                                creative: el.attr('data-creative'),
                                position: el.attr('data-position')
                            }]
                    }
                }
            });
    });

    // Reamaze click
    const reamazeElm = cr$.byId('olark-tab');
    reamazeElm.click(reamazeClickHandler);

    cr$.byId('onlineChatReamaze').click(() => reamazeElm.click());

    PopupsManager.triggerPageEnter();
});
